import React, { useEffect, useMemo, useRef, useState } from "react";

export default function Constellation({
    starCount = 250,
    meteorsPerMinute = 45, // ⬅️ 유성 낙하 빈도 (평균)
}) {
    const [viewport, setViewport] = useState({
        w: typeof window !== "undefined" ? window.innerWidth : 0,
        h: typeof window !== "undefined" ? window.innerHeight : 0,
    });

    const [meteor, setMeteor] = useState(null);
    const meteorTimerRef = useRef(null);
    const removeMeteorTimerRef = useRef(null);

    const styles = useMemo(() => ["style1", "style2", "style3", "style4","style5", "style6", "style7", "style8"], []);
    const sizes = useMemo(() => ["tam1", "tam1", "tam1", "tam2", "tam3"], []);
    const opacities = useMemo(
        () => ["opacity1", "opacity1", "opacity1", "opacity2", "opacity2", "opacity3", "opacity4", "opacity5", "opacity6", "opacity7", "opacity8"],
        []
    );

    const randInt = (min, max) => Math.floor(Math.random() * (max - min)) + min;

    const stars = useMemo(() => {
        const arr = [];
        for (let i = 0; i < starCount; i++) {
            const left = randInt(0, viewport.w);
            const top = randInt(0, viewport.h);
            const delay = `.${randInt(0, 9)}s`;
            const cls = [
                "estrela",
                styles[randInt(0, styles.length)],
                opacities[randInt(0, opacities.length)],
                sizes[randInt(0, sizes.length)],
            ].join(" ");
            arr.push({
                key: `star-${i}`,
                className: cls,
                style: { left, top, position: "absolute", animationDelay: delay },
            });
        }
        return arr;
    }, [starCount, viewport.w, viewport.h, styles, sizes, opacities]);

    useEffect(() => {
        const onResize = () =>
            // setViewport({ w: window.innerWidth, h: window.innerHeight });
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    useEffect(() => {
        const randInt = (min, max) => Math.floor(Math.random() * (max - min)) + min;

        const sampleInterval = () => {
            const lambda = meteorsPerMinute / 60000;
            const u = Math.random();
            return Math.max(300, Math.floor(-Math.log(1 - u) / lambda));
        };

        const schedule = () => {
            const delay = sampleInterval();
            meteorTimerRef.current = setTimeout(() => {

                const count = 1 + (Math.random() < 0.4 ? Math.floor(Math.random() * 2) : 0);
                const meteors = Array.from({ length: count }, (_, i) => ({
                    className: `meteoro ${styles[randInt(0, styles.length)]}`,
                    key: `meteor-${Date.now()}-${i}`,
                }));
                setMeteor(meteors);


                removeMeteorTimerRef.current = setTimeout(() => {
                    setMeteor(null);
                    schedule();
                }, 1000);
            }, delay);
        };

        schedule();

        return () => {
            clearTimeout(meteorTimerRef.current);
            clearTimeout(removeMeteorTimerRef.current);
        };
    }, [meteorsPerMinute, styles]);

    return (
        <>
            {/* 별자리 */}
            <div
                className="constelacao"
                style={{
                    position: "fixed",
                    inset: 0,
                    overflow: "hidden",
                    pointerEvents: "none",
                }}
            >
                {stars.map((s) => (
                    <span key={s.key} className={s.className} style={s.style} />
                ))}
            </div>

            {/* 유성 */}
            <div
                className="chuvaMeteoro"
                style={{
                    position: "fixed",
                    inset: 0,
                    overflow: "hidden",
                    pointerEvents: "none",
                }}
            >
                {meteor &&
                    meteor.map((m) => (
                        <div key={m.key} className={m.className} />
                    ))}
            </div>
        </>
    );
}